import { render } from "./SubmissionActionModal.vue?vue&type=template&id=4111a5f0&scoped=true"
import script from "./SubmissionActionModal.vue?vue&type=script&lang=js"
export * from "./SubmissionActionModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/previewModal.scss?vue&type=style&index=0&id=4111a5f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4111a5f0"]])

export default __exports__